import React from 'react';
import { Trans } from '@lingui/react/macro';

import { Box, Button, Flex, Heading, Text } from '@rover/kibble/core';

interface HomeAddressCardProps {
  address: string;
  onEditClick: () => void;
}

const HomeAddressCard: React.FC<HomeAddressCardProps> = ({ address, onEditClick }) => {
  return (
    <Box p="2x" minWidth="240px">
      <Flex flexDirection="column" pb="2x">
        <Heading size="200" mb="1x">
          <Trans>Home</Trans>
        </Heading>
        <Text size="100" mb="1x">
          {address}
        </Text>
      </Flex>
      <Button size="small" alignSelf="flex-start" m="0x" onClick={onEditClick}>
        <Trans>Edit</Trans>
      </Button>
    </Box>
  );
};

export default HomeAddressCard;
